import { Link } from "react-router-dom";
import { UserButton } from "@clerk/react";
import { PiStudentDuotone, PiCodeBlockDuotone, PiLightningDuotone, PiFileArrowUpDuotone, PiVideoCameraDuotone } from "react-icons/pi";
import "./Dashboard.scss";

// Mindmap removed per request.
const CARDS = [
  {
    to: "/study",
    label: "STUDY COMPANION",
    icon: <PiStudentDuotone color="#ff00ff" size={64} />, // Magenta
    desc: "AI-powered study sessions with real-time voice",
    color: "#a1e4f2", // Light blue
    rotation: "-3deg",
  },
  {
    to: "/dsa",
    label: "DSA PRACTICE",
    icon: <PiCodeBlockDuotone color="#ff4600" size={64} />, // Deep Orange
    desc: "Solve data structures & algorithms live.",
    color: "#f5c518", // Yellow
    rotation: "-1deg",
  },
  {
    to: "/course",
    label: "COURSE GENERATOR",
    icon: <PiLightningDuotone color="#8a2be2" size={64} />, // Blue Violet
    desc: "Generate a full structured course on any topic.",
    color: "#ff4600", // Orange
    rotation: "3deg",
  },
  {
    to: "/resupload",
    label: "RESUME UPLOAD",
    icon: <PiFileArrowUpDuotone color="#00e5ff" size={64} />, // Cyan
    desc: "Upload your resume and get AI-driven questions.",
    color: "#ffffff", // White
    rotation: "0deg",
  },
  {
    to: "/codevid",
    label: "CODEVID",
    icon: <PiVideoCameraDuotone color="#00ff88" size={64} />, // Neon Green
    desc: "Record & playback interactive coding lessons.",
    color: "#c084fc", // Purple
    rotation: "2deg",
  },
];

export default function Dashboard() {
  return (
    <div className="dashboard-neobrutal-max">
      
      {/* Background visual noise */}
      <div className="bg-dots" />
      <div className="bg-stripes" />

      {/* Marquee Banner */}
      <div className="marquee-container">
        <div className="marquee">
          <span>HAZARDOUS AI TRAINING ENVIRONMENT — </span>
          <span>ENTER AT YOUR OWN RISK — </span>
          <span>HAZARDOUS AI TRAINING ENVIRONMENT — </span>
          <span>ENTER AT YOUR OWN RISK — </span>
          <span>HAZARDOUS AI TRAINING ENVIRONMENT — </span>
          <span>ENTER AT YOUR OWN RISK — </span>
          <span>HAZARDOUS AI TRAINING ENVIRONMENT — </span>
          <span>ENTER AT YOUR OWN RISK — </span>
        </div>
      </div>

      <div className="dashboard-wrapper">
        <header className="brutal-header">
          <div className="branding-block">
             <div className="pill-badge">v2.0 // DESTRUCTIVE BUILD //</div>
             <h1 className="manifesto-title">
               MULTIMODAL<br />
               <span className="skewed-highlight">CONSOLE</span>
             </h1>
             <div className="subtitle-box">
               <p>Select your operational protocol below.</p>
             </div>
          </div>

          <div className="user-terminal">
            <div className="terminal-bar">
               <span className="dot" />
               <span className="dot" />
               <span className="dot" />
               <span className="title">user_process.exe</span>
            </div>
            <div className="terminal-inner">
               <span className="prompt">C:\&gt; execute auth</span>
               <div className="auth-btn-wrapper">
                  <UserButton />
               </div>
            </div>
          </div>
        </header>

        {/* Decorative Absolutes */}
        <div className="sticker sticker-1">100% RAW</div>
        <div className="sticker sticker-2">UNPOLISHED</div>

        <main className="brutal-grid">
          {CARDS.map((card, idx) => (
            <Link 
              key={card.to} 
              to={card.to} 
              className="os-window-card" 
              style={{ 
                "--card-color": card.color,
                "--base-rotation": card.rotation,
                "animationDelay": `${idx * 0.1}s`
              } as React.CSSProperties}
            >
              {/* Fake OS Window Header */}
              <div className="os-window-header">
                <span className="os-title">{card.label.toLowerCase()}.exe</span>
                <div className="os-controls">
                  <div className="os-btn">_</div>
                  <div className="os-btn block">◻</div>
                  <div className="os-btn close">×</div>
                </div>
              </div>

              {/* Card Body */}
              <div className="os-body">
                <div className="icon-wrapper">
                  <span className="huge-icon">{card.icon}</span>
                </div>
                <div className="text-content">
                  <h2>{card.label}</h2>
                  <p>{card.desc}</p>
                </div>
                <div className="execute-arrow">
                  <span>RUN PROGRAM →</span>
                </div>
              </div>
            </Link>
          ))}
        </main>
      </div>
    </div>
  );
}
